// Bulgarian
export default {
  newVersionAvailable: 'Налична е нова версия',
  versionInfo:
    'Нова версия на {appName} е налична. Моля, презаредете страницата, за да актуализирате до версия {version}.',
  reload: 'Презареди',
  later: 'По-късно',
  intl_addr_country: 'Държава',
  intl_addr_address1: 'Адрес',
  intl_addr_address2: 'Адрес 2',
  intl_addr_address3: 'Адрес 3',
  intl_addr_address4: 'Адрес 4',
  intl_addr_city: 'Град',
  intl_addr_state: 'Област',
  intl_addr_zipCode: 'Пощенски код',
  intl_addr_longitude: 'Дължина',
  intl_addr_latitude: 'Ширина',
  intl_addr_department: 'Отдел',
  intl_addr_suburb: 'Предградие',
  intl_addr_postalCode: 'Пощенски код',
  intl_addr_province: 'Област',
  intl_addr_neighborhood: 'Квартал',
};
